module.exports = __webpack_public_path__ + "static/media/foto.ecf44abb.png";